import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconPieChart = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.05494C12 2.77059 11.879 2.49969 11.6671 2.30999C11.4553 2.1203 11.1727 2.02975 10.8901 2.06099C5.88912 2.61383 2 6.85206 2 12C2 17.5229 6.47716 22 12 22C17.148 22 21.3862 18.1109 21.939 13.1099C21.9703 12.8273 21.8797 12.5447 21.69 12.3329C21.5004 12.1211 21.2294 12 20.9451 12H12V3.05494ZM4 12C4 8.27259 6.54987 5.13961 10 4.25183V13C10 13.5523 10.4477 14 11 14H19.7482C18.8604 17.4502 15.7275 20 12 20C7.58172 20 4 16.4183 4 12ZM15.3332 2.56949C15.0272 2.46132 14.6877 2.50844 14.4226 2.69587C14.1576 2.8833 14 3.18772 14 3.51234V9.00004C14 9.55232 14.4477 10 15 10H20.4878C20.8124 10 21.1168 9.84246 21.3043 9.57741C21.4917 9.31237 21.5388 8.97283 21.4306 8.66676C20.4261 5.82479 18.1753 3.57401 15.3332 2.56949ZM16 8.00004V5.07029C17.2143 5.77289 18.2272 6.78577 18.9298 8.00004H16Z"
        />
      </svg>
    );
  }
);
